import { hideControlsClassName } from '../classNames';
export var getControlsWrapperClassName = function getControlsWrapperClassName(wasPlayedOnce) {
  return !wasPlayedOnce ? '' : hideControlsClassName;
};